"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageIndexProvider = exports.StackedPagesProvider = exports.StackedPagesIndexContext = exports.StackedPagesContext = void 0;

const react_1 = require("react");

exports.StackedPagesContext = react_1.createContext({
  stackedPages: [],
  stackedPageStates: {},
  navigateToStackedPage: () => {},
  highlightStackedPage: () => {}
});
exports.StackedPagesIndexContext = react_1.createContext(0);
exports.StackedPagesProvider = exports.StackedPagesContext.Provider;
exports.PageIndexProvider = exports.StackedPagesIndexContext.Provider;